import { mlbHigherIsBetter } from '../../../../utils/mlbUtils';
import { isHigherBetter as nflHigherIsBetter, nflTeams } from '../../../../utils/nflUtils';
import { higherIsBetter as nbaHigherIsBetter, nbaTeams } from '../../../../utils/nbaUtils';
import { byString } from '../../../../utils/byString';

// MLB Label Definitions
const mlbLabels = {
    batting: {
        "AB":"AB",
        "R":"R",
        "H":"H",
        "HR": "HR",
        "RBI":"RBIs",
        "BB":"BB",
        "HBP":"HBP",
        "SO":"SO",
        "PA":"PA",
        "BA":"BA",
        "OBP":"OBP",
        "SLG":"SLG",
        "OPS":"OPS",
        "Pit":"Pitches Taken",
        "Str":"Strikes Taken",
        "singles":"Singles",
        "doubles":"Doubles",
        "triples":"Triples",
        "SF":"SF",
        "SB":"SB",
        "CS":"CS",
        "LOB":"LOB",
    },
    pitching: {
        "IP":"Innings Pitched",
        "H":"Hits Allowed",
        "R":"Runs Allowed",
        "ER":"Earned Runs",
        "BB":"Batters Walked",
        "SO":"Strike Outs Thrown",
        "HR":"Home Runs Allowed",
        "ERA":"ERA",
        "BF":"Batters Faced",
        "Pit":"Pitches Thrown",
        "Str":"Strikes Thrown"
    }
};

// NBA Label Definitions
const nbaLabels = {
    teamScoring: {
        "stats.Points1Q": "1st Qtr Pts",
        "stats.Points2Q": "2nd Qtr Pts",
        "stats.Points3Q": "3rd Qtr Pts",
        "stats.Points4Q": "4th Qtr Pts",
        "stats.Points1H": "1st Half Pts",
        "stats.Points2H": "2nd Half Pts",
        "stats.Points": "Pts Scored",
        "calculated.PercentagePtsFrom2": "% of Pts from Two",
        "calculated.PercentagePtsFrom3": "% of Pts from Three",
        "calculated.PercentagePtsFromFt": "% of Pts from FT",
        "calculated.Points1QPercentage": "1st Qtr Pts %",
        "calculated.Points2QPercentage": "2nd Qtr Pts %",
        "calculated.Points3QPercentage": "3rd Qtr Pts %",
        "calculated.Points4QPercentage": "4th Qtr Pts %",
        "calculated.Points1HPercentage": "1st Half Pts %",
        "calculated.Points2HPercentage": "2nd Half Pts %",

    },
    oppScoring: {
        "stats.OppPoints1Q": "1st Qtr Pts Allowed",
        "stats.OppPoints2Q": "2nd Qtr Pts Allowed",
        "stats.OppPoints3Q": "3rd Qtr Pts Allowed",
        "stats.OppPoints4Q": "4th Qtr Pts Allowed",
        "stats.OppPoints1H": "1st Half Pts Allowed",
        "stats.OppPoints2H": "2nd Half Pts Allowed",
        "stats.OppPoints": "Pts Allowed",
        "calculated.OppPercentagePtsFrom2": "% of Pts from Two Against",
        "calculated.OppPercentagePtsFrom3": "% of Pts from Three Against",
        "calculated.OppPercentagePtsFromFt": "% of Pts from FT Against",
        "calculated.OppPoints1QPercentage": "1st Qtr Pts Allowed %",
        "calculated.OppPoints2QPercentage": "2nd Qtr Pts Allowed %",
        "calculated.OppPoints3QPercentage": "3rd Qtr Pts Allowed %",
        "calculated.OppPoints4QPercentage": "4th Qtr Pts Allowed %",
        "calculated.OppPoints1HPercentage": "1st Half Pts Allowed %",
        "calculated.OppPoints2HPercentage": "2nd Half Pts Allowed %",
    },
    teamOffense: {
        "calculated.PtsPerPossession": "Pts per Possession",
        "stats.TrueShootingAttempts": "True Shooting Attempts",
        "calculated.FieldGoalPercentage": "FG %",
        "calculated.TwoPtFgPercentage": "2pt FG %",
        "calculated.ThreePtFgPercentage": "3pt FG %",
        "calculated.FtPercentage": "FT %",
        "calculated.EffectiveFgPercentage": "Effective FG %",
        "calculated.TrueShootingPercentage": "True Shooting %",
        "calculated.AssistToTurnoverRatio": "Assist to Turnover Ratio",
        "calculated.FtRate": "FT Rate",
        "calculated.TurnoverPercentage": "Turnover Percentage",
        "calculated.ThreePtAttemptRate": "3pt Attempt Rate",
        "stats.OffensiveRebounds": "Off Rebounds",
        "calculated.OffReboundPercentage": "Off Rebound Percentage",
        "calculated.OffensiveEfficiencyRating": "Off Efficiency Rating",
        "calculated.AssistPercentage": "Assist Percentage",
        "stats.Assists": "Assists",
        "calculated.TurnoverRate": "Turnover Rate",
        "stats.FieldGoalsMade": "FG Made",
        "stats.FieldGoalsAttempted": "FG Attempted",
        "stats.TwoPointersMade": "2pt Made",
        "stats.TwoPointersAttempted": "2pt Attempts",
        "stats.ThreePointersMade": "3pt Made",
        "stats.ThreePointersAttempted": "3pt Attempts",
        "stats.FreeThrowsMade": "FT Made",
        "stats.FreeThrowsAttempted": "FT Attempts",
        "stats.DoubleDoubles": "Double Doubles",
        "stats.TripleDoubles": "Triple Doubles",
        "stats.OppBlockedShots": "Shots Blocked",
        "stats.Turnovers": "Turnovers Committed",
        "calculated.OppBlockToFoulRatio": "Opp. Block to Foul Ratio",
    },
    teamDefense: {
        "calculated.DefensiveRating": "Defensive Rating",
        "calculated.OppPtsPerPossession": "Opp. Pts per Possession",
        "stats.OppTrueShootingAttempts": "Opp. True Shooting Attempts",
        "calculated.OppFieldGoalPercentage": "Opp. FG %",
        "calculated.OppTwoPtFgPercentage": "Opp. 2pt FG %",
        "calculated.OppThreePtFgPercentage": "Opp. 3pt FG %",
        "calculated.OppFtPercentage": "Opp. FT %",
        "calculated.OppEffectiveFgPercentage": "Opp. Effective FG %",
        "calculated.OppTrueShootingPercentage": "Opp. True Shooting %",
        "calculated.OppAssistToTurnoverRatio": "Opp. Assist to Turnover Ratio",
        "calculated.OppFtRate": "Opp. FT Rate",
        "calculated.OppTurnoverPercentage": "Opp. Turnover Percentage",
        "calculated.OppThreePtAttemptRate": "Opp. 3pt Attempt Rate",
        "stats.OppOffensiveRebounds": "Opp. Off Rebounds",
        "calculated.DefReboundPercentage": "Def Rebound Percentage",
        "calculated.OppOffReboundPercentage": "Opp. Off Rebound Percentage",
        "calculated.OppAssistPercentage": "Opp. Assist Percentage",
        "stats.OppAssists": "Opp. Assists",
        "calculated.OppTurnoverRate": "Opp. Turnover Rate",
        "stats.OppFieldGoalsMade": "Opp. FG Made",
        "stats.OppFieldGoalsAttempted": "Opp. FG Attempted",
        "stats.OppTwoPointersMade": "Opp. 2pt Made",
        "stats.OppTwoPointersAttempted": "Opp. 2pt Attempts",
        "stats.OppThreePointersMade": "Opp. 3pt Made",
        "stats.OppThreePointersAttempted": "Opp. 3pt Attempts",
        "stats.OppFreeThrowsMade": "Opp. FT Made",
        "stats.OppFreeThrowsAttempted": "Opp. FT Attempts",
        "stats.OppDoubleDoubles": "Opp. Double Doubles",
        "stats.OppTripleDoubles": "Opp. Triple Doubles",
        "stats.BlockedShots": "Opp. Shots Blocked",
        "stats.OppTurnovers": "Opp. Turnovers",
        "calculated.BlockToFoulRatio": "Block to Foul Ratio",
    },
    twoWayStats: {
        "calculated.Pace": "Pace",
        "calculated.NetRating": "Net Rating",
        "calculated.TotalReboundPercentage": "Total Rebound Percentage",
        "stats.Rebounds": "Total Rebounds",
        "stats.OppRebounds": "Opp. Total Rebounds",
        "stats.PersonalFouls": "Personal Fouls",
        "stats.OppPersonalFouls": "Opponent Personal Fouls",
    }
};

// NFL Label Definitions
const nflLabels = {
    teamScoring: {
        'off.scoring.1': '1st Qtr Pts Scored',
        'off.scoring.2': '2nd Qtr Pts Scored',
        'off.scoring.3': '3rd Qtr Pts Scored',
        'off.scoring.4': '4th Qtr Pts Scored',
        'off.scoring.1H': '1st Half Pts Scored',
        'off.scoring.2H': '2nd Half Pts Scored',
        'off.scoring.FG': 'Full Game Pts Scored',
        'calculated.off.pct_pts_1h': '% of Pts from 1st Half',
        'calculated.off.pct_pts_2h': '% of Pts from 2nd Half',
        'calculated.off.pct_pts_fg': '% of Pts from FG',
        'off.redzone.att': 'Redzone Attempts',
        'calculated.off.redzone_conv_rate': 'Redzone Conv. Rate',
        'off.tds_total': 'Touchdowns Scored',
        'calculated.off.pass_td_pct': '% of Tds Passing',
        'calculated.off.rush_td_pct': '% of Tds Rushing',
    },
    oppScoring: {
        'def.pts_allowed.1': '1st Qtr Pts Allowed',
        'def.pts_allowed.2': '2nd Qtr Pts Allowed',
        'def.pts_allowed.3': '3rd Qtr Pts Allowed',
        'def.pts_allowed.4': '4th Qtr Pts Allowed',
        'def.pts_allowed.1H': '1st Half Pts Allowed',
        'def.pts_allowed.2H': '2nd Half Pts Allowed',
        'def.pts_allowed.FG': 'Full Game Pts Allowed',
        'calculated.def.pct_pts_1h': '% of Pts from 1st Half',
        'calculated.def.pct_pts_2h': '% of Pts from 2nd Half',
        'calculated.def.redzone_conv_rate': 'Redzone Conv. Rate',
        'def.redzone.att': 'Redzone Attempts Allowed',
        'def.tds_total': 'Touchdowns Allowed',
        'calculated.def.pass_td_pct': '% of Tds Allowed Passing',
        'calculated.def.rush_td_pct': '% of Tds Allowed Rushing',
    },
    teamPassing: {
        "calculated.off.comp_pct": "Pass Comp %",
        "calculated.off.adj_comp_pct": "Adj Pass Comp %",
        "off.passing.yds": "Passing Yds",
        "off.passing.tds": "Passing Tds",
        "off.passing.ints": "Interceptions Thrown",
        "calculated.off.int_rate": "Interception Rate",
        "off.passing.first_downs": "First Downs Passing",
        "calculated.off.first_downs_per_pass": "First Downs / Pass Att",
        "calculated.off.first_down_pass_pct": "% of First Downs Passing",
        "off.passing.intended_air_yds": "Intended Air Yds",
        "off.passing.comp_air_yds": "Completed Air Yds",
        "calculated.off.air_yds_per_pass_comp": "Air Yds / Comp",
        "off.passing.yac": "Yac",
        "calculated.off.yac_per_comp": "Yac / Comp",
        "calculated.off.ybc_per_comp": "Ybc / Comp",
        "calculated.off.pass_yac_pct": "% of Yds After catch",
        "calculated.off.pass_ybc_pct": "% of Yds Before catch",
        "off.passing.pass_rating": "Pass Rating",
        "calculated.off.poor_throw_rate": "Poor Throw Rate",
    },
    oppPassing: {
        "calculated.def.pass_comp_pct": "Pass Comp % Allowed",
        "def.yds_passing": "Passing Yds Allowed",
        "def.tds_pass": "Passing Tds Allowed",
        "def.passing.ints": "Interceptions",
        "calculated.def.int_rate": "Interception Rate",
        "def.first_downs_passing": "First Downs Passing Allowed",
        "calculated.def.first_downs_per_pass": "First Downs / Pass Att Allowed",
        "calculated.def.first_down_pass_pct": "% of First Downs Allowed Passing",
        "def.pass_int_air_yds": "Intended Air Yds Against",
        "def.pass_air_yds": "Completed Air Yds Allowed",
        "calculated.def.air_yds_per_pass_comp": "Air Yds / Comp Allowed",
        "def.passing.yac": "Yards After Catch Allowed",
        "calculated.def.yac_per_comp": "Yac / Comp Allowed",
        "calculated.def.ybc_per_comp": "Ybc / Comp Allowed",
        "calculated.def.pass_yac_pct": "% of Yds After Catch",
        "calculated.def.pass_ybc_pct": "% of Yds Before Catch",
        "def.pass_rating": "Pass Rating Against",
        "calculated.def.poor_throw_rate": "Poor Throw Rate Against",
    },
    teamRushing: {
        "off.rushing.att": "Rushing Attempts",
        "off.rushing.tds": "Rushing Tds",
        "calculated.off.rush_td_pct": "% of Tds Rushing",
        "off.rushing.yds": "Rushing Yds",
        "off.rushing.ybc": "Ybc",
        "off.rushing.yac": "Yac",
        "calculated.off.yds_per_carry": "Yds / Carry",
        "calculated.off.rush_avg_ybc": "Ybc / Carry",
        "calculated.off.rush_avg_yac": "Yac / Carry",
        "calculated.off.rush_yac_pct": "% of Yds After Contact",
        "calculated.off.rush_ybc_pct": "% of Yds Before Contact",
        "off.rushing.first_downs": "First Downs Rushing",
        "calculated.off.first_downs_per_rush": "First Downs / Rush Att",
        "calculated.off.first_down_rush_pct": "% of First Downs Rushing",
        "off.rushing.broken_tackles": "Broken Tackles"
    },
    oppRushing: {
        "def.rush_att": "Rushing Att Against",
        "def.tds_rush": "Rushing Tds Allowed",
        "calculated.def.rush_td_pct": "% of Tds Rushing Against",
        "def.yds_rushing": "Rushing Yds Allowed",
        "def.rush_ybc": "Ybc Allowed",
        "def.rush_yac": "Yac Allowed",
        "calculated.def.yds_per_carry": "Yds / Carry Allowed",
        "calculated.def.rush_avg_ybc": "Ybc / Carry Allowed",
        "calculated.def.rush_avg_yac": "Yac / Carry Allowed",
        "calculated.def.rush_yac_pct": "% of Yds After Contact Against",
        "calculated.def.rush_ybc_pct": "% of Yds Before Contact Against",
        "def.first_downs_rushing": "First Downs Rushing Allowed",
        "calculated.def.first_downs_per_rush": "First Downs / Rush Att Allowed",
        "calculated.def.first_down_rush_pct": "% of First Downs Rushing Against"
    },
    teamScheme: {
        "off.offensive_plays": "Offensive Plays",
        "calculated.off.pass_rate": "Pass Rate",
        "calculated.off.rush_rate": "Rush Rate",
        "calculated.off.first_downs_per_play": "First Downs / Play",
        "calculated.off.yds_per_play": "Yds / Play",
        "off.possession": "Possession (Mins)",
        "calculated.off.plays_per_min_poss": "Plays / Min Poss",
        "calculated.off.seconds_per_play": "Seconds / Play",
        "off.third_downs.att": "3rd Downs Attempted",
        "calculated.off.third_down_conv_rate": "3rd Down Conv. Rate",
        "off.fourth_downs.att": "4th Downs Attempted",
        "calculated.off.fourth_down_conv_rate": "4th Down Conv. Rate",
    },
    oppScheme: {
        "def.defensive_plays": "Defensive Plays",
        "calculated.def.pass_rate": "Pass Rate Against",
        "calculated.def.rush_rate": "Rush Rate Against",
        "calculated.def.first_downs_per_play": "First Downs / Play Allowed",
        "calculated.def.yds_per_play": "Yds / Play Allowed",
        // "def.possession": "Opp. Possession (Mins)",
        // "calculated.def.plays_per_min_poss": "Plays / Min Poss Against",
        // "calculated.def.seconds_per_play": "Seconds / Play Against",
        "def.third_down_att": "3rd Down Att Against",
        "calculated.def.third_down_conv_rate": "3rd Down Conv. Rate Against",
        "def.fourth_down_att": "4th Down Att Against",
        "calculated.def.fourth_down_conv_rate": "4th Down Conv. Rate Allowed",
        "calculated.off.first_down_penalty_pct": "% of First Downs by Penalty",
    },
    setbacks: {
        "off.turnovers": "Turnovers",
        "off.negative_plays": "Negative Plays",
        "calculated.off.negative_play_rate": "Negative Play Rate",
        "off.passing.ints": "Interceptions Thrown",
        "calculated.off.int_rate": "Interception Rate",
        "off.fumbles": "Fumbles",
        "off.fumbles_lost": "Fumbles Lost",
        "off.poor_throws": "Poor Throws",
        "calculated.off.bad_throw_rate": "Poor Throw Rate",
        "off.receiving.drops": "Dropped Passes",
        "calculated.off.drop_rate": "Drop Rate",
        "off.sacks.taken": "Sacks Taken",
        "off.sacks.yds_lost": "Sack Yds Lost",
        "calculated.off.sack_rate": "Sack Rate",
        "calculated.off.pressure_rate": "Player Pressure Rate",
        "calculated.off.pressure_to_sack_rate": "Player Pressures to Sack Rate",
    },
    dImpact: {
        "def.takeaways": "Takeaways",
        "def.passing.ints": "Interceptions",
        "def.passing.int_tds": "Pick 6s",
        "calculated.def.int_rate": "Interception Rate",
        "def.negative_plays": "Negative Plays",
        "calculated.def.negative_play_rate": "Negative Play Rate",
        "def.fumbles.forced": "Fumbles Forced",
        "def.fumbles.recovered": "Fumbles Recovered",
        "def.fumbles.tds": "Fumbles Returned",
        "def.player_hurries": "QB Hurries",
        "def.player_pressures": "Player Pressures",
        "def.player_blitzes": "Player Blitzes",
        "def.qb_knockdowns": "QB Knockdowns",
        "def.missed_tackles": "Missed Tackles",
        "def.passing.passes_defended": "Passes Defended",
        "calculated.def.first_down_penalty_pct": "% of First Downs by Penalty",
        "calculated.def.pressure_rate": "Player Pressure Rate",
        "calculated.def.pressure_to_sack_rate": "Player Pressures to Sack Rate",
    }
};

// Consolidated higherIsBetter mappings
const higherIsBetterMappings = {
    mlb: mlbHigherIsBetter,
    nfl: nflHigherIsBetter,
    nba: nbaHigherIsBetter
};

// Consolidated labels
const sportLabels = {
    mlb: mlbLabels,
    nba: nbaLabels,
    nfl: nflLabels
};

// Available tabs for each sport
const sportTabs = {
    mlb: [
        { value: 'batting', label: 'Batting' },
        { value: 'pitching', label: 'Pitching' }
    ],
    nba: [
        { value: 'teamScoring', label: 'Team Scoring' },
        { value: 'oppScoring', label: 'Opponent Scoring' },
        { value: 'teamOffense', label: 'Team Offense' },
        { value: 'teamDefense', label: 'Team Defense' },
        { value: 'twoWayStats', label: 'Two-Way Stats' }
    ],
    nfl: [
        { value: 'teamScoring', label: 'Team Scoring' },
        { value: 'oppScoring', label: 'Opponent Scoring' },
        { value: 'teamPassing', label: 'Team Passing' },
        { value: 'oppPassing', label: 'Opponent Passing' },
        { value: 'teamRushing', label: 'Team Rushing' },
        { value: 'oppRushing', label: 'Opponent Rushing' },
        { value: 'teamScheme', label: 'Team Scheme & Pace' },
        { value: 'oppScheme', label: 'Opp. Scheme & Pace' },
        { value: 'setbacks', label: 'Offensive Setbacks' },
        { value: 'dImpact', label: 'Defensive Impact' }
    ]
};

// Get labels for a specific sport and category
export const getLabels = (sport, category) => {
    return sportLabels[sport]?.[category] || {};
};

// Get tabs for a specific sport
export const getTabs = (sport) => {
    return sportTabs[sport] || [];
};

// Check if higher is better for a specific stat
export const isHigherBetter = (sport, statKey) => {
    return higherIsBetterMappings[sport]?.[statKey] || false;
};

// Get all available sports
export const getSupportedSports = () => {
    return Object.keys(sportLabels);
};

// Get stat key for comparison based on sport and category
export const getStatKey = (sport, category, stat) => {
    switch(sport) {
        case 'mlb':
            return `${category}.${stat}`;
        case 'nba':
            return stat; // NBA uses full stat paths like "stats.Points"
        case 'nfl':
            if(category.toLowerCase().includes('off')) {
                return `off.${stat}`;
            } else if(category.toLowerCase().includes('def')) {
                return `def.${stat}`;
            } else if(category.toLowerCase().includes('st')) {
                return `st.${stat}`;
            } else {
                return stat;
            }
        default:
            return stat;

    }
};

// Extract stats from game data based on sport and category
export const extractStats = (sport, category, game, dataType = null) => {

    // Return null if there is no home or away properties in the game
    if (!game?.home || !game?.away) return null;

    // Return null if the stats are not populated for both teams, sport dependent
    if (sport === 'nfl' && (!game.home.off || !game.away.off)) return null;
    if (sport === 'nba' && (!game.home.stats || !game.away.stats)) return null;
    if (sport === 'mlb' && (!game.home.batting || !game.away.batting || !game.home.pitching || !game.away.pitching)) return null;
    
    // If dataType is provided, use normalized stats
    if (dataType && game.home.normalized_stats && game.away.normalized_stats) {
        return extractNormalizedStats(sport, category, game, dataType);
    }

    // Original raw stats extraction logic
    switch(sport) {
        case 'mlb':
            if (category === 'batting' && 'batting' in game.home && 'batting' in game.away) {
                const keys = Object.keys(game.home.batting);
                let stats = {};
                keys.forEach(stat => {
                    stats[stat] = [game.home.batting[stat], game.away.batting[stat]];
                });
                return stats;
            } else if (category === 'pitching' && 'pitching' in game.home && 'pitching' in game.away) {
                const keys = Object.keys(game.home.pitching);
                let stats = {};
                keys.forEach(stat => {
                    stats[stat] = [game.home.pitching[stat], game.away.pitching[stat]];
                });
                return stats;
            }
            break;

        case 'nba':
            if ('stats' in game.home && 'stats' in game.away) {
                const nbaStatKeys = nbaLabels[category];
                if (!nbaStatKeys) return null;
                
                let stats = {};
                Object.keys(nbaStatKeys).forEach(stat => {
                    const statSplit = stat.split(".");
                    if (game.home[statSplit[0]] && game.away[statSplit[0]]) {
                        stats[stat] = [game.home[statSplit[0]][statSplit[1]], game.away[statSplit[0]][statSplit[1]]];
                    }
                });
                return stats;
            }
            break;

        case 'nfl':
            if ('off' in game.home && 'off' in game.away && 'def' in game.home && 'def' in game.away) {
                let stats = {};
                
                switch(category) {
                    case 'genOff':
                        const genOffKeys = Object.keys(game.home.off)
                            .filter(key => typeof game.home.off[key] !== 'object');
                        genOffKeys.forEach(stat => {
                            stats[stat] = [game.home.off[stat], game.away.off[stat]];
                        });
                        break;
                    case 'rushOff':
                        if (game.home.off.rushing && game.away.off.rushing) {
                            const rushKeys = Object.keys(game.home.off.rushing);
                            rushKeys.forEach(stat => {
                                stats[stat] = [game.home.off.rushing[stat], game.away.off.rushing[stat]];
                            });
                        }
                        break;
                    case 'passOff':
                        if (game.home.off.passing && game.away.off.passing) {
                            const passKeys = Object.keys(game.home.off.passing);
                            passKeys.forEach(stat => {
                                stats[stat] = [game.home.off.passing[stat], game.away.off.passing[stat]];
                            });
                        }
                        if (game.home.off.sacks && game.away.off.sacks) {
                            const sackKeys = Object.keys(game.home.off.sacks);
                            sackKeys.forEach(stat => {
                                stats[stat] = [game.home.off.sacks[stat], game.away.off.sacks[stat]];
                            });
                        }
                        break;
                    case 'passDef':
                        if (game.home.def.passing && game.away.def.passing) {
                            const passDefKeys = Object.keys(game.home.def.passing);
                            passDefKeys.forEach(stat => {
                                stats[stat] = [game.home.def.passing[stat], game.away.def.passing[stat]];
                            });
                        }
                        break;
                    case 'tackDef':
                        if (game.home.def.tackles && game.away.def.tackles) {
                            const tackKeys = Object.keys(game.home.def.tackles);
                            tackKeys.forEach(stat => {
                                stats[stat] = [game.home.def.tackles[stat], game.away.def.tackles[stat]];
                            });
                        }
                        // Add missed_tackles from def level
                        if (game.home.def.missed_tackles !== undefined && game.away.def.missed_tackles !== undefined) {
                            stats["missed_tackles"] = [game.home.def.missed_tackles, game.away.def.missed_tackles];
                        }
                        break;
                    case 'genDef':
                        if (game.home.def.fumbles && game.away.def.fumbles) {
                            const fumbKeys = Object.keys(game.home.def.fumbles);
                            fumbKeys.forEach(stat => {
                                stats[stat] = [game.home.def.fumbles[stat], game.away.def.fumbles[stat]];
                            });
                        }
                        const genDefKeys = Object.keys(game.home.def)
                            .filter(key => typeof game.home.def[key] !== 'object' && key !== "missed_tackles");
                        genDefKeys.forEach(stat => {
                            stats[stat] = [game.home.def[stat], game.away.def[stat]];
                        });
                        break;
                }
                return stats;
            }
            break;
    }
    
    return null;
};

// Helper function to extract normalized stats
const extractNormalizedStats = (sport, category, game, dataType) => {
    const labels = getLabels(sport, category);
    const stats = {};
    Object.keys(labels).forEach(stat => {
        const statKey = getStatKey(sport, category, stat);
        const normalizedKey = `${statKey}.${dataType}`;

        const homeValue = byString(game.home.normalized_stats, normalizedKey);
        const awayValue = byString(game.away.normalized_stats, normalizedKey);
        
        if (homeValue !== undefined && awayValue !== undefined) {
            stats[stat] = [homeValue, awayValue];
        }
    });
    
    return Object.keys(stats).length > 0 ? stats : null;
};

// Get team names for display
export const getTeamNames = (sport, game) => {
    switch(sport) {
        case 'mlb':
            return {
                home: game.home?.team || 'Home',
                away: game.away?.team || 'Away'
            };
        case 'nba':
            return {
                home: nbaTeams[game.home?.team_id] || game.home?.team_id || 'Home',
                away: nbaTeams[game.away?.team_id] || game.away?.team_id || 'Away'
            };
        case 'nfl':
            return {
                home: nflTeams[game.home?.team_id] || game.home?.team_id || 'Home',
                away: nflTeams[game.away?.team_id] || game.away?.team_id || 'Away'
            };
        default:
            return {
                home: 'Home',
                away: 'Away'
            };
    }
};